import { render, staticRenderFns } from "./PagoError.vue?vue&type=template&id=03c81ea6&"
import script from "./PagoError.vue?vue&type=script&lang=js&"
export * from "./PagoError.vue?vue&type=script&lang=js&"
import style0 from "./PagoError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports